import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { LoginComponent } from "./login.component";
import { SharedModule } from "src/app/shared/shared.module";
import { OAuthCallbackComponent } from './oauth-callback/oauth-callback.component';

const routes: Routes = [
    {
      path: '',
      component: LoginComponent
    },
    { 
        path: 'oauth/callback', 
        component: OAuthCallbackComponent 
    },
  ];
@NgModule({
    declarations: [
        LoginComponent,
        OAuthCallbackComponent
    ],
    imports: [
        HttpClientModule,
        CommonModule,
        SharedModule,
        RouterModule.forChild(routes),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    exports:[
        LoginComponent
    ]
  })
  export class LoginModule { }
    export function createTranslateLoader(http: HttpClient) {
        return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  }